module.exports = __webpack_public_path__ + "img/dice-6.bb012be9.png";